import React, { FC, memo, useMemo } from 'react'

import Map from '../../Map'

import { ICampus } from '../types'

const InfrastructureMap: FC<ICampus> = (props) => {
  const { campus } = props

  const pins = campus
    .map(({ objects, type }) =>
      objects.map((pin) => {
        const { address, description } = pin
        const { latitude, longitude } = pin.addressPoint

        return {
          name: type.name,
          color: type.color,
          address,
          latitude,
          longitude,
          description,
        }
      })
    )
    .flat(2)

  const center = useMemo(() => {
    if (pins && pins.length > 0) {
      const pin = pins[0]

      if (pin && pin.latitude && pin.longitude) {
        return [pin.longitude, pin.latitude]
      }

      return undefined
    }

    return undefined
  }, [pins])

  return (
    <Map
      zoomControl
      fullscreenControl
      pins={pins}
      componentHeight={291}
      center={center}
    />
  )
}

export default memo(InfrastructureMap)
